"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_datepicker_1 = require("react-datepicker");
var react_redux_1 = require("react-redux");
var react_datepicker_2 = __importDefault(require("react-datepicker"));
var languageSlice_1 = require("../../../features/languages/languageSlice");
var deviceHelper_1 = require("../../../helpers/deviceHelper");
var hy_1 = __importDefault(require("date-fns/locale/hy"));
var ru_1 = __importDefault(require("date-fns/locale/ru"));
var Localization_1 = require("../../../constants/Localization");
require("react-datepicker/dist/react-datepicker.css");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
react_datepicker_1.registerLocale(Localization_1.Language.hy, hy_1.default);
react_datepicker_1.registerLocale(Localization_1.Language.ru, ru_1.default);
var IconInput = react_1.forwardRef(function (_a, ref) {
    var value = _a.value, onClick = _a.onClick, onChange = _a.onChange;
    var t = react_i18next_1.useTranslation('common').t;
    return (react_1.default.createElement("div", { className: "ui icon input", onClick: onClick, ref: ref },
        react_1.default.createElement("input", { type: "text", placeholder: t('DATEPICKER.PLACEHOLDER'), value: value, onChange: onChange }),
        react_1.default.createElement("i", { className: "calendar alternate outline icon" })));
});
var BlDateTime = function (_a) {
    var minDate = _a.minDate, rest = __rest(_a, ["minDate"]);
    var currentLanguage = react_redux_1.useSelector(languageSlice_1.selectCurrentLanguage);
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.date_picker },
        react_1.default.createElement(react_datepicker_2.default, __assign({}, rest, { customInput: react_1.default.createElement(IconInput, null), withPortal: deviceHelper_1.isMobile(), locale: currentLanguage, minDate: minDate, showYearDropdown: true, showPopperArrow: false }))));
};
exports.default = BlDateTime;
